<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="data.total" @update="updatePage">
      <el-table-column prop="userName" :label="$t('activity.points.name')" />
      <el-table-column prop="phoneNumber" :label="$t('other.visitor.phone')">
        <template #default="{row}">
          {{ row.phoneNumber &&  (String(row.phoneNumber).slice(0,3)+'****'+String(row.phoneNumber).slice(7))}}
        </template>
      </el-table-column>
      <el-table-column prop="company" :label="$t('activity.sale.company')" />
      <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" />
      <el-table-column prop="status" :label="$t('points.exchange.status')" />
      <el-table-column prop="permissionStartTime" :label="$t('system.authapply.effectiveTime')" />
      <el-table-column prop="permissionEndTime" :label="$t('system.authapply.expirationTime')" />
      <el-table-column :label="$t('activity.list.operation')" fixed="right" width="120px">
        <template #default="scope" style="padding-bottom: 20px;">
          <el-button type="text" size="mini" @click="editDetail(scope.row)">{{$t('system.emailnotice.edit')}}</el-button>
          <el-button type="text" style="color: #f56c6c;" size="mini" @click="deleteDetail(scope.row)">{{$t('activity.packetjoin.delete')}}</el-button>
        </template>
      </el-table-column>
    </Table>
    <el-dialog v-model="data.dialogFormVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="detailformRef" class="dialog-form" :model="detailform" :rules="detailformRules" label-width="125px">
        <el-form-item :label="$t('activity.points.name')">
          <el-input disabled v-model="detailform.userName" :placeholder="$t('activity.points.name')" />
        </el-form-item>
        <el-form-item :label="$t('other.visitor.phone')">
          <el-input disabled v-model="detailform.phoneNumber" :placeholder="$t('other.visitor.phone')" />
        </el-form-item>
        <el-form-item :label="$t('activity.packetjoin.robotCode')">
          <el-input disabled v-model="detailform.robotId" :placeholder="$t('activity.packetjoin.robotCode')" />
        </el-form-item>
        <el-form-item :label="$t('system.authapply.effectiveTime')" prop="permissionStartTime">
          <el-date-picker
            v-model="detailform.permissionStartTime"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :placeholder="$t('system.authapply.effectiveTime')"
            :disabled-date="disabledDate"
          />
        </el-form-item>
        <el-form-item :label="$t('system.authapply.expirationTime')" prop="permissionEndTime">
          <el-date-picker
            v-model="detailform.permissionEndTime"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :placeholder="$t('system.authapply.expirationTime')"
            :disabled-date="disabledDate"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "@/common/mixin";
import { ref, reactive } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { useI18n } from 'vue-i18n'
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const { t } = useI18n()
    const params = [
      {
        key: "userName",
        value: "",
        label: t('activity.points.name'),
      },
      {
        key: "phoneNumber",
        value: "",
        label: t('other.visitor.phone'),
      },
      {
        key: "robotId",
        value: "",
        label: t('activity.packetjoin.robotCode'),
      }
    ];
    const detailform = reactive({
        id: '',
        userName: "",
        phoneNumber: "",
        robotId: "",
        permissionStartTime: "",
        permissionEndTime: ""
    })
    const detailformRef = ref(null)
    const detailformRules = reactive({
      permissionStartTime: {
        required: true,
        message: t('system.authapply.selectEffectiveTime'),
        trigger: 'change',
      },
      permissionEndTime: {
        required: true,
        message: t('system.authapply.selectExpirationTime'),
        trigger: 'change',
      },
    })
    var query = {
      userName: "", // 姓名
      phoneNumber: "", // 电话
      robotId: "", // 机器人编码
    };
    const data = reactive({
      dialogFormVisible: false,
      page: 1,
      size: 10,
      total: 0,
    });
    const tableDataList = ref([]);

    const getData = async () => {
      console.log("query", query);
      try {
        const res = await request("permissionList", {
          ...query,
          page: data.page,
          size: data.size,
        });
        console.log("permissionList", res);
        tableDataList.value = res.records;
        data.total = res.total;
      } catch (error) {
        console.error(error);
      }
    };
    const searchData = (data) => {
      query = data;
      getData();
    };
    const updatePage = (page, size) => {
      data.page = page || 1;
      data.size = size || 10;
      getData();
    };
    const editDetail = async (row) => {
      try {
        for (let key of Object.keys(detailform)) {
          if (row[key]) {
            detailform[key] = row[key];
          } else {
            detailform[key] = "";
          }
        }
        detailform.id = row.id
        data.dialogFormVisible = true
        console.log("editDetail", row);
      } catch (error) {
        console.error(error);
      }
    };
    const deleteDetail = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('activity.list.confirmDelete'),
          {
            confirmButtonText: t('activity.list.confirm1'),
            cancelButtonText: t('activity.list.cancel'),
            type: 'warning',
          }
        )
        await request("deletePermission", {
          id: row.id
        })
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.packetreceive.deleteSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    } 
    const editSubmit = async () => {
      console.log('onSubmit', detailform)
      try {
        detailformRef.value && await detailformRef.value.validate()
        await request("changePermission", {
          id: detailform.id,
          permissionStartTime: detailform.permissionStartTime,
          permissionEndTime : detailform.permissionEndTime,
        })
        data.dialogFormVisible = false
        getData()
        ElMessage({
          showClose: true,
          type: "success",
          message: t('system.authority.modifySuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const disabledDate = function(time) {
      return time.getTime() < (Date.now() - 86400000)
    }
    getData();
    return {
      params,
      query,
      data,
      tableDataList,
      detailform,
      detailformRef,
      detailformRules,
      getData,
      searchData,
      updatePage,
      editDetail,
      deleteDetail,
      editSubmit,
      disabledDate
    };
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>